import { FormSectionHandler } from '../entity.handler';
import { ClientResponse, ClientUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField } from '../utils';

interface EditorValues {
    address?: string;
    city?: string;
    state?: string;
    country?: string;
    code?: string;
}

export class SharedAddressSectionHandler implements FormSectionHandler<ClientResponse, EditorValues> {

    type = 'form';
    icon = 'address-card';
    bulk = false;
    readonly = false; // always let admin users edit their own address

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private entityType: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.CLIENT.ADDRESS.${key}`, values);
    }

    applyUpdate(entity: ClientResponse, payload: ClientUpdateRequest): Promise<ClientResponse> {

        switch (this.entityType) {
            case 'client': return this.admin.applyUpdate(api => api.accounts.updateClientDetails(entity.id, payload));
            case 'vendor': return this.admin.applyUpdate(api => api.accounts.updateVendorDetails(entity.id, payload));
            case 'distributor': return this.admin.applyUpdate(api => api.accounts.updateDistributorDetails(entity.id, payload));
            default:
                throw new Error(`Update for '${this.entityType}' not supported`);
        }
    }

    mapEntityToEditor(entity: ClientResponse): Promise<EditorValues> {
        return Promise.resolve(entity.address || {});
    }

    mapEditorToEntity(entity: any, values: EditorValues): Promise<any> {
        entity.address = EntityUtils.mergeFields(['address', 'city', 'state', 'country', 'code'], values, {});
        return Promise.resolve(entity);
    }

    getFields(entity: ClientResponse): Promise<FormBuilderField[]> {
        return Promise.all([
            this.admin.getCountries(),
        ]).then(([countries]) => {
            return [
                TextField('address', this.translate('FIELDS.ADDRESS'), true, 1, 255),
                TextField('city', this.translate('FIELDS.CITY'), true, 1, 255),
                TextField('state', this.translate('FIELDS.STATE'), true, 1, 255),
                TextField('code', this.translate('FIELDS.CODE'), true, 1, 255),
                ComboField('country', this.translate('FIELDS.COUNTRY'), true, countries.map(x => ({ key: x.id, value: x.name }))),
            ].filter(x => x);

        }).then(fields => EntityUtils.prepareBulk(!entity, [], fields));
    }

}
